module.exports = __webpack_public_path__ + "static/media/btn_sair.27e0eabd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/btn_sair.svg
// module id = 645
// module chunks = 0